import script from "./AppHeaderSubNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderSubNavigation.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderSubNavigation.vue?vue&type=style&index=0&id=02844352&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02844352"]])

export default __exports__